import types from "../types";
import { push } from "../../router/history";
import {
  showSuccessSnackbar,
  showFailSnackbar,
} from "../../common/actions/snackbar";

export function forgotPassword(values){
  return async (dispatch) => {
    return dispatch({
      type: types.FORGOT_PASSWORD,
      payload: {
        request: {
          url: "forgot-password",
          method: "POST",
          data: values,
        },
      },
    })
    .then(async ({ payload }) => {
      push('/')
      dispatch(
        showSuccessSnackbar(
          "Sucesso! Um E-mail foi enviado para o cadastro da nova senha."
        )
      );
    })
    .catch((error) => {
      console.log("error---", error);
      dispatch(
        showFailSnackbar("Ops! Algo deu errado, tente novamente mais tarde.")
      );
    });

  }
}